// Retrograde (Mercury): a word that spells another word backward scores more.
// Only the Worker has the dictionary, so it notes on the accepted word
// whether its reverse is a word (facts.reverse); palindromes count.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const retrograde: AlignmentDef = {
  id: 'retrograde',
  planet: 'mercury',
  name: 'Retrograde',
  text: () => `Words that spell another word backward score +${N.retrogradePercent}%.`,
  wordPercent: (c) => (c.constellation.facts?.reverse ? N.retrogradePercent : 0),
};
